import { IncomingHttpHeaders } from 'node:http';
import { Methods as SearchConditionLabelAPI } from '@doda/api-client/aspida/api/v1/front/jobs/search/label';
import { apiClient } from '@doda/api-client/util/apiClient';

export type SearchConditionLabelQuery = NonNullable<
  SearchConditionLabelAPI['get']['query']
>;

/**
 * 検索条件ラベルを取得
 * @param {SearchConditionLabelQuery} params
 * @return {SearchConditionLabelResponse}
 */
export const getSearchConditionLabel = async (
  params: SearchConditionLabelQuery,
  headers?: IncomingHttpHeaders
) => {
  const res = await apiClient.api.v1.front.jobs.search.label.$get({
    query: params,
    config: {
      headers,
    },
  });
  return res;
};
